"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEuroAmount = void 0;
const formatEuroAmount = (amount) => {
    if (Number.isInteger(amount))
        return `${amount} €`;
    return `${amount.toFixed(2)} €`;
};
exports.formatEuroAmount = formatEuroAmount;
